const ESCALA = 10000;

function aEntero(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * ESCALA);
}

export function redondearDinero(valor, decimales = 2) {
  const factor = 10 ** decimales;
  const n = Number(valor);
  if (!Number.isFinite(n)) return 0;
  return Math.round((n + Number.EPSILON) * factor) / factor;
}

export function sumarDinero(...valores) {
  const total = valores.reduce((acc, v) => acc + aEntero(v), 0);
  return redondearDinero(total / ESCALA, 4);
}

export function restarDinero(a, b) {
  return redondearDinero((aEntero(a) - aEntero(b)) / ESCALA, 4);
}

export function multiplicarDinero(a, b) {
  return redondearDinero((aEntero(a) * Number(b)) / ESCALA, 4);
}

export function dividirDinero(a, b) {
  const den = Number(b);
  if (!den) return 0;
  return redondearDinero(Number(a) / den, 4);
}

export function aDosDecimales(valor) {
  return redondearDinero(valor, 2);
}
